import type { i18n as I18nType, TFunction } from 'i18next';

import { GradeOption } from '../types/finderConfig';

export interface GradeLabel {
  /** i18n label for standard grades, else the config label. */
  text: string;
  /** True only for the config-label fallback. */
  allowGoogleTranslate: boolean;
}

const gradeKey = (value: string): string => `finder.grade_option.${value}`;

// App i18n handles standard grades (PreK, TK, K, 1–12) for consistent names, but
// only while the config label still matches our default English wording. A district
// that customized the label (or a non-standard value) keeps its own English text,
// localized by Google Translate.
export const resolveGradeLabel = (
  option: GradeOption,
  t: TFunction,
  i18n: I18nType,
): GradeLabel => {
  const key = gradeKey(option.value);
  if (i18n.exists(key) && i18n.t(key, { lng: 'en' }) === option.label) {
    return { text: t(key), allowGoogleTranslate: false };
  }
  return { text: option.label, allowGoogleTranslate: true };
};

// HTML `translate` attribute for a resolved label.
export const gradeTranslateAttr = (label: GradeLabel): 'yes' | 'no' => (label.allowGoogleTranslate ? 'yes' : 'no');
